import React from 'react';

import { DOCUSIGN } from '../../../../theme/tokens';
import { Picture, Ring, Seal, SealDisc, SealGlyph, SealGroove, Sheets } from './DeclarationPicture.styles';

export type DeclarationPictureProps = {
  /** When the seal stamps, in ms from mount. */
  delayMs: number;
};

/**
 * Step 1's picture: the License Holder Declaration, a sheet of paper over a second one, and the
 * brand's seal (a shield, in the brand orange) stamping onto it with a ring that spreads out.
 * Decorative: the step's own line says what to do.
 */
export const DeclarationPicture = ({ delayMs }: DeclarationPictureProps): React.ReactElement => (
  <Picture viewBox="0 0 240 148" aria-hidden="true" focusable="false">
    <Sheets>
      <rect
        x="72"
        y="30"
        width="112"
        height="140"
        rx="9"
        transform="rotate(7 128 100)"
        fill={DOCUSIGN.paper}
        fillOpacity="0.4"
        stroke={DOCUSIGN.paperEdge}
      />
      <rect x="62" y="24" width="116" height="150" rx="9" fill={DOCUSIGN.paper} stroke={DOCUSIGN.paperEdge} />
    </Sheets>
    <rect x="76" y="40" width="50" height="7" rx="3.5" fill={DOCUSIGN.ink} fillOpacity="0.85" />
    <rect x="76" y="56" width="88" height="4" rx="2" fill={DOCUSIGN.line} />
    <rect x="76" y="66" width="76" height="4" rx="2" fill={DOCUSIGN.line} />
    <rect x="76" y="76" width="84" height="4" rx="2" fill={DOCUSIGN.line} />
    <rect x="76" y="86" width="56" height="4" rx="2" fill={DOCUSIGN.line} />
    <path d="M76 122h46" stroke={DOCUSIGN.rule} strokeWidth="1.4" strokeLinecap="round" />
    <g transform="translate(150 116)">
      <Ring r="20" $delayMs={delayMs} />
      <Seal $delayMs={delayMs}>
        <SealDisc r="20" />
        <SealGroove r="15.5" />
        <SealGlyph d="M0-9l7.5 3V0c0 5-3.3 8-7.5 9.5C-4.2 8-7.5 5-7.5 0v-6z" />
        <SealGlyph d="M-3.2.2l2.2 2.2 4.2-4.4" />
      </Seal>
    </g>
  </Picture>
);

export default DeclarationPicture;
